import { Card } from '@startupquickstart/frontend';
import { Activity } from 'lucide-react';

import { EventActivityFeed } from '@/components/activity/EventActivityFeed';

/** Keep the live panel snappy — the Activity tab has the full history. */
const LIVE_FEED_LIMIT = 30;

/**
 * Compact realtime activity feed for the command center. Reuses the shared
 * EventActivityFeed rows (plain variant) inside a panel-style card.
 *
 * @param props - Target event id.
 */
export function LiveActivityPanel({ eventId }: { eventId: string }) {
  return (
    <Card className="gap-0 overflow-hidden py-0">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <h3 className="font-mono text-[0.6875rem] font-medium tracking-[0.15em] text-muted-foreground uppercase">
          Activity
        </h3>
        <Activity className="h-4 w-4 text-muted-foreground" />
      </div>
      <div className="max-h-[28rem] overflow-y-auto p-3">
        <EventActivityFeed eventId={eventId} limit={LIVE_FEED_LIMIT} variant="plain" />
      </div>
    </Card>
  );
}
